import React, { useState, useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { useQueryParamString } from 'react-use-query-param-string'
import * as ClientSideSearch from 'js-search'

import Layout from '../components/Layout'
import { MetaData } from '../components/common/meta'
import Listing from '../components/Listing'
import RecentPosts from '../components/RecentPosts'

function Search({ location }) {
  const [skip, setSkip] = useState(0)
  const limit = 5

  const {
    allGhostPost: { nodes: recentPosts },
    dataset,
  } = useStaticQuery(graphql`
    query SearchQuery {
      allGhostPost(sort: { published_at: DESC }, limit: 5) {
        nodes {
          ...GhostPostFields
        }
      }
      dataset: allGhostPost(
        filter: { tags: { elemMatch: { slug: { eq: "knowledge-base" } } } }
        sort: { published_at: DESC }
      ) {
        nodes {
          id
          slug
          title
          published_at
          excerpt
          plaintext
          primary_author {
            slug
            name
          }
          tags {
            slug
            name
          }
        }
      }
    }
  `)

  const [query] = useQueryParamString('q', '')

  const results = useMemo(() => {
    const algo = new ClientSideSearch.Search('id')
    algo.addIndex('title')
    algo.addIndex('plaintext')
    algo.addDocuments(dataset.nodes)
    return algo.search(query)
  }, [query, dataset])

  useEffect(() => {
    if (window && window.scroll) {
      window.scroll(0, 0)
    }
  }, [skip])

  return (
    <>
      <MetaData location={location} title="Search" type="website" />
      <Layout sidebar>
        <div className="container">
          <div className="flex justify-center">
            <div id="left-area" className="max-w-3xl flex-1">
              <article className="et_pb_post post type-post status-publish format-standard hentry">
                <h1 className="main_title">Results for &quot;{query}&quot;</h1>
                {results.length ? null : (
                  <>
                    <p>
                      No results found. Try refining your search in our{' '}
                      <Link to="/knowledge-base">knowledge base</Link>.
                    </p>
                    <p>
                      Or if the topic you need isn&apos;t listed contact us at{' '}
                      <a
                        href="mailto:support@affio.co.uk"
                        title="Contact support"
                      >
                        support@affio.co.uk
                      </a>
                    </p>
                  </>
                )}
              </article>
              <Listing
                posts={results.slice(skip * limit, limit + skip * limit)}
              />
              <div className="pagination clearfix">
                <div className="alignleft">
                  {limit + skip * limit <= results.length - 1 ? (
                    <button
                      type="button"
                      className="btn btn-link"
                      title="See older entries"
                      onClick={() => setSkip(skip + 1)}
                    >
                      « Older Entries
                    </button>
                  ) : null}
                </div>
                <div className="alignright">
                  {limit + skip * limit > 5 ? (
                    <button
                      type="button"
                      className="btn btn-link"
                      title="See next entries"
                      onClick={() => setSkip(skip - 1 <= 0 ? 0 : skip - 1)}
                    >
                      Next Entries »
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
            <div id="sidebar">
              <RecentPosts posts={recentPosts} />
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

Search.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default Search
